import { render } from "./DetailvueApproval.vue?vue&type=template&id=98ed29d0&scoped=true&bindings={}"
import script from "./DetailvueApproval.vue?vue&type=script&lang=ts"
export * from "./DetailvueApproval.vue?vue&type=script&lang=ts"

import "./DetailvueApproval.vue?vue&type=style&index=0&id=98ed29d0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-98ed29d0"

export default script